import { Box, Typography } from '@mui/material'
import React from 'react'

import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  MembershipCreateForm,
  MembershipCreateFormProps,
} from './MembershipCreateForm'
export * from './fragments'

export type State = {
  artistId: string
  startMembershipNumber: number | null
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: MembershipCreateFormProps['onSubmit']
}

export const ConsoleMembershipCreateTemplate: Template<State, Action> = ({
  state,
  onSubmit,
}) => {
  const { routerNames, routerPages } = useRouter()
  const { t } = useTranslation('consoleMembershipCreate')

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsoleMembershipCreate} />

      <ConsoleBaseLayout
        header={{
          back: true,
          defaultBackPage: routerPages.ConsoleMembership,
          title: t('title'),
        }}
      >
        <Box sx={{ px: 5, pt: 5 }}>
          <Typography variant="h5">{t('membershipTitle')}</Typography>
          <Typography
            component="p"
            variant="caption"
            color="text.secondary"
            sx={{ pt: 2 }}
          >
            {t('titleDesc')}
          </Typography>
        </Box>
        <MembershipCreateForm
          startMembershipNumber={state.startMembershipNumber}
          onSubmit={onSubmit}
        />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
